import Header from '../../components/Header'
import MediaMatch from '../../components/MediaMatch'

import Footer from '../../components/Footer'
import * as S from '../../styles/page-profile'

import { Breadcrumb, BreadcrumbItem } from '../../styles/breadcrumb'
import ProfileSideMenu from '../../components/MenuProfile'
import { ProfileTitle } from '../../components/FormChangePassword/styles'

import { useEffect, useState } from 'react'
import { converterNegociacaoBoleto } from '../../pages/Negociacoes/fetch'

import Loader from '../../components/Loader'

import { Link, useHistory, useLocation, useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import NegociacaoDetalhe from '../../components/NegociacaoDetalhe'
import IconRefresh from '../../assets/img/icon-refresh.svg'
import { CardButton } from '../../components/FichaNegociacao/styles'
import PaymentCardsModal from '../../components/MyPaymentCards/PaymentCardsModal'
import { useToast } from '../../hooks/toast'
import pedidos from '../../api/pedidos'
import ProdutosEsgotadosModal from '../../components/MyPaymentCards/ProdutosEsgotadosModal'
import { getLocalStorageLog } from '../../utils/traceLogAcessos'
import { sendToConverterCheckout } from '../../utils/rotaConverter'
import { GetNegociacaoRequest } from '../../types/negociacao'
import { useQuery, useQueryClient } from 'react-query'
import { getNegociacaoList } from '../../hooks/negociacao/useNegociacao'

function NegociacoesItem() {
  const { addToast }: any = useToast()
  const params: any = useParams()
  const history = useHistory()
  const queryClient = useQueryClient()

  const { idNegociacao }: any = useParams()
  const [pedidoFilter, setPedidoFilter] = useState()
  const [showModalPayment, setShowModalPayment] = useState(false)
  const [showModalMessage, setShowModalMessage] = useState(false)
  const [esgotadoBoletoMessage, setEsgotadoBoletoMessage] = useState('')
  const [userCards, setUserCards] = useState([])
  const [loader, setLoader] = useState(false)

  const [filterParams, setFilterParams] = useState<GetNegociacaoRequest>({
    OpcaoFiltro: '',
    Numero: '',
    DataInicial: '',
    DataFinal: '',
    Page: 1,
    PageSize: 10
  })

  const { data, isLoading, isError } = useQuery(
    [
      'negociacao',
      filterParams.OpcaoFiltro,
      filterParams.Numero,
      filterParams.DataInicial,
      filterParams.DataFinal,
      filterParams.Page,
      filterParams.PageSize
    ],
    () =>
      getNegociacaoList(
        filterParams.OpcaoFiltro,
        filterParams.Numero,
        filterParams.DataInicial,
        filterParams.DataFinal,
        filterParams.Page,
        filterParams.PageSize
      ),
    {
      onError: () => {
        addToast({
          type: 'error',
          title: 'Não foi possível realizar busca',
          description: `Verifique os campos e tente novamente`
        })
      },
      staleTime: 1000 * 60 // 1 minuto,
    }
  )

  const pedido = data?.Data.filter((item) => item.Id == idNegociacao)[0]

  const openModalPayment = () => {
    setShowModalPayment((prev) => !prev)
  }

  const openModalMessage = () => {
    setShowModalMessage((prev) => !prev)
  }

  const location = useLocation()

  //datalayer push on load
  useEffect(() => {
    if (!!loader)
      !!window.dataLayer && window.dataLayer.push({ event: 'negociacao' })
  }, [loader])

  useEffect(() => {
    getLocalStorageLog(location.pathname)

    // fetch('', params?.idNegociacao)

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    })
  }, [])

  const showButtonConverter = (pedido) => {
    if (
      (pedido?.DescricaoSituacao === 'Negociação Avaliada' &&
        pedido?.Expirado === false) ||
      (pedido?.DescricaoSituacao === 'Cotação' && pedido?.Expirado === false)
    ) {
      return true
    } else {
      return false
    }
  }

  const handleConverter = async () => {
    const formaPagamento = pedido.DetalhePagamento.DescricaoFormaPagamento

    if (formaPagamento.includes('Boleto') || formaPagamento.includes('Pix')) {
      setLoader(true)

      let res: any = await converterNegociacaoBoleto(pedido, 'N')
      queryClient.refetchQueries('negociacao')

      if (res?.includes('Convertido')) {
        // history.push('/finalizado', {
        //   idPedido: res,
        //   type: formaPagamento
        // })
        setLoader(false)

        sendToConverterCheckout(res, formaPagamento)
      } else if (res?.includes('esgotou')) {
        // addToast({
        //   type: 'info',
        //   title:
        //     'Problema ao gerar Pedido. Será necessário fazer uma nova(cotação ou negociação).',
        //   description: `${res}`,
        //   timer: 20000
        // })
        setEsgotadoBoletoMessage(res)
        // setEsgotadoMessage(res)
        openModalMessage()
        setLoader(false)
      } else {
        addToast({
          type: 'error',
          title: 'Ocorreu um erro ao gerar Pedido. Tente novamente',
          description: `${res}`
        })
        setLoader(false)
      }
    } else {
      openModalPayment()
    }
  }

  return (
    <>
      {!!isLoading || !!loader ? <Loader /> : null}

      <PaymentCardsModal
        showModal={showModalPayment}
        setShowModal={setShowModalPayment}
        cardData={userCards}
        setUserCards={setUserCards}
        isLoading={isLoading}
        pedido={pedido}
        setPedido={setPedidoFilter}
        type="N"
        formas={undefined} // formas={formas}
      />

      <ProdutosEsgotadosModal
        message={esgotadoBoletoMessage}
        showModal={showModalMessage}
        setShowModal={setShowModalMessage}
      />

      <Header />
      <S.Profile className="perfil">
        <S.PageContent className="page-content">
          <S.Wrapper className="wrapper">
            <S.ColGroup className="col-group">
              <ProfileSideMenu />
              <S.ProfileContent className="col-9">
                {/* Área para inserir os novo componentes criados para ficar ao lado do menu lateral de perfil */}
                <Breadcrumb>
                  <BreadcrumbItem>Inicio</BreadcrumbItem>
                  <BreadcrumbItem>Negociações</BreadcrumbItem>
                  <BreadcrumbItem>Negociação Nº {idNegociacao}</BreadcrumbItem>
                </Breadcrumb>

                <S.HeaderCotacaoNegociacao>
                  <ProfileTitle>Negociação Nº {idNegociacao}</ProfileTitle>

                  <MediaMatch greaterThan="800px">
                    {!!showButtonConverter(pedido) && (
                      <CardButton
                        className="button-small button-success"
                        onClick={handleConverter}
                      >
                        <img src={IconRefresh} alt="Converter" />
                        Converter Pedido
                      </CardButton>
                    )}
                  </MediaMatch>
                </S.HeaderCotacaoNegociacao>

                <NegociacaoDetalhe pedidoFilter={data} />

                <MediaMatch lessThan="800px">
                  {!!showButtonConverter(pedido) && (
                    <CardButton className="mobile" onClick={handleConverter}>
                      <img src={IconRefresh} alt="Converter" />
                      Converter Pedido
                    </CardButton>
                  )}
                </MediaMatch>

                {/* Fim da área de conteúdo da página */}
              </S.ProfileContent>
            </S.ColGroup>
          </S.Wrapper>
        </S.PageContent>
      </S.Profile>
      <Footer />
    </>
  )
}

export default NegociacoesItem
